$(document).ready(function () {
    $("#add-slider").on('click',function (e){
        e.preventDefault()
        $('#form-slider').trigger("reset")
        $('.item-imagen-slider').attr('src', '').attr('alt', '');
        $("#item-route").val('/admin/img-slider/add')
        $("#modal-slider").modal('show')
    })

    $(document).on('click','.update-slider', function (e){
        let info = $(this).data('info')
        $("#item-method").val('PUT')
        $(".slider-img").val('')
        $.each(info,function (index,value){
            $("#item-"+index).val(value)
            if (index == "imagen") {
                $("#item-image").attr("src",'../images/banners/'+value);
            }
        })
        $("#item-route").val('/admin/img-slider/update')
        $("#modal-slider").modal('show')
    })

    $("#form-slider").on('submit', function (e){
        e.preventDefault()
        let method = $("#item-method").val()
        let data = new FormData(this)
        let route = $("#item-route").val()
        let msg = route == "/admin/img-slider/add" ? "Registro agregado" : "Registro actualizado"
        sendInfo(route,data,msg)
    })


    $(document).on('click','.update-status-slider',function (e){
        e.preventDefault()
        $(".loader_").addClass("loading")
        var item = $(this).data('id')
        let data = new FormData()
        data.append('item',item)
        sendInfo("/admin/update-status-slider",data,'Registro actualizado')
    })

    $(document).on('click','.delete-status-slider',function (e){
        e.preventDefault()
        var item = $(this).data('id')
        let data = new FormData()
        data.append('item',item)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $(".loader_").addClass("loading")
                sendInfo("/admin/delete-status-slider",data,'Registro eliminado')
            }
        })

    })

    function sendInfo(route,data,msg) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route,
            type: "POST",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    $("#modal-slider").modal('hide')
                    alertSuccess(msg)
                    document.getElementById('div_partials_sliders').innerHTML = response;
                    $("#list-sliders-home").sortable({
                        update: function (event, ui) {
                            update(event, ui); // Llamada a la función update al mover un elemento
                        }
                    });
                }, 1000)

            },
            error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function clearSpan() {
        $(".item-error-country").text('');
        $(".item-error-url").text('');
        $(".item-error-imagen").text('');
    }

})
